const quoteRequest = {

    ui: {},

    init: function () {
        this.bindUI();
        this.bindEvents();

        // this.initSlider();
        this.addressSelection();
        this.initInputs();
    },

    bindUI: function () {
        this.ui.$popinFormAddress = $('.js-quote-request-address-shipping-form');
        this.ui.$form = $('.js-quote-request-form')

        this.ui.$showCarpet = $('.js-show-carpet');
        this.ui.$showRug = $('.js-show-rug');
        this.ui.$showUpload = $('.js-show-upload');
        this.ui.$disableBtn = $('.js-disable-btn');
        this.ui.$disableBtnFabric = $('.js-disable-btn-fabric');
        this.ui.$noShow = $('.js-no-show');
        this.ui.$guestShowButton = $('.js-guest-show-button');
        this.ui.$addressSelection = $('.js-address-shipping-selection input[name="addressSelection"]');
        this.ui.$addReference = $('.js-quoteRequest__addReference');
        this.ui.$showDimensions = $('.js-show-dimensions');
        this.ui.$showDimensionsCustom = $('.js-show-dimensions-custom');
        this.ui.$showOneRef = $('.js-show-one-ref');
        this.ui.$showManyRef = $('.js-show-many-ref');
        this.ui.$showNoRef = $('.js-show-no-ref');
        this.ui.$subBtn = $('.js-subBtn');
        this.ui.$addBtn = $('.js-addBtn');
        this.ui.$inputQuantity = $("#furniture_project_definition_quantity");


        $('.js-tabListSplide__link[href="#step_2"]').addClass('disabled');
        this.ui.$allElementsFormStep1 = this.ui.$form.find("#step_1").find("input, select, textarea");

        $('.js-quoteRequest-submit').addClass('disabled');
        this.ui.$allElementsFormStep2 = this.ui.$form.find("#step_2").find("input, select, textarea");
    },

    bindEvents: function () {
        this.ui.$popinFormAddress.on('submit', this.onPopinFormAddressSubmit.bind(this));

        this.ui.$showCarpet.on('click', this.showCarpet.bind(this));
        this.ui.$showRug.on('click', this.showRug.bind(this));
        this.ui.$showUpload.on('click', this.showUpload.bind(this));
        this.ui.$disableBtn.on('click', this.disableBtn.bind(this));
        this.ui.$disableBtnFabric.on('click', this.disableBtnFabric.bind(this));
        this.ui.$guestShowButton.on('click', this.guestShowButton.bind(this));
        this.ui.$addressSelection.on('change', this.addressSelection.bind(this));
        this.ui.$addReference.on('click', this.addReference.bind(this));
        this.ui.$showDimensions.on('click', this.showDimensions.bind(this));
        this.ui.$showDimensionsCustom.on('click', this.showDimensionsCustom.bind(this));
        this.ui.$showOneRef.on('click', this.showOneRef.bind(this));
        this.ui.$showManyRef.on('click', this.showManyRef.bind(this));
        this.ui.$showNoRef.on('click', this.showNoRef.bind(this));

        this.ui.$subBtn.on('click', this.subBtn.bind(this));
        this.ui.$addBtn.on('click', this.addBtn.bind(this));

        this.ui.$form.on('submit', this.submitOrGoToStep2IfValid.bind(this));
        this.ui.$allElementsFormStep1.on('change', this.disableSubmitIfNotValidForm.bind(this));
        this.ui.$allElementsFormStep1.on('input', this.disableSubmitIfNotValidForm.bind(this));

        this.ui.$allElementsFormStep2.on('change', this.disableSubmitStep2IfNotValidForm.bind(this));
        this.ui.$allElementsFormStep2.on('input', this.disableSubmitStep2IfNotValidForm.bind(this));
        $('.js-address-shipping-selection').on('change', this.disableSubmitStep2IfNotValidForm.bind(this));
        $('.js-infos-shipping-other-address').on('change', this.disableSubmitStep2IfNotValidForm.bind(this));

        $('.js-quote-request-next-step').on('click', function (e) {
            let link = $('.js-tabListSplide__link[href="#step_2"]');
            link.click();
            link[0].scrollIntoView();
        })
    },

    submitOrGoToStep2IfValid: function (e) {
        if (this.disableSubmitIfNotValidForm()) {
            // si on est pas à l'étape on bloque le submit et on passe à l'étape 2
            if (!$(".js-tabListSplide__link[href='#step_2']").hasClass("active")) {
                e.preventDefault();
                $(".js-tabListSplide__link[href='#step_2']").click();
            }
        } else {
            e.preventDefault();
        }
    },

    disableSubmitIfNotValidForm: function () {
        for (var i = 0; i < this.ui.$allElementsFormStep1.length; i++) {
            // si un des champs n'est pas valid, on bloque le submit
            if (!this.ui.$allElementsFormStep1.eq(i)[0].validity.valid) {
                $('.js-quote-request-next-step').attr('disabled', true);
                $('.js-tabListSplide__link[href="#step_2"]').addClass('disabled')
                return false;
            }
        }
        $('.js-quote-request-next-step').removeAttr('disabled');
        $('.js-tabListSplide__link[href="#step_2"]').removeClass('disabled');
        return true;
    },

    disableSubmitStep2IfNotValidForm: function () {
        const submitBtn = this.ui.$form.find('.js-quoteRequest-submit')

        let disableBtn = false;
        if (1 === this.ui.$addressSelection.length) {
            if (!this.ui.$addressSelection.prop('checked')) {
                submitBtn.addClass('disabled');
                disableBtn = true
            } else if (1 === this.ui.$addressSelection.closest('.js-address-shipping-selection').find('p button').length) {
                submitBtn.addClass('disabled');
                disableBtn = true
            }
        } else if (1 < this.ui.$addressSelection.length) {
            this.ui.$addressSelection.each(i => {
                if (this.ui.$addressSelection.eq(i).prop('checked')) {
                    if (1 === this.ui.$addressSelection.eq(i).closest('.js-address-shipping-selection').find('p button').length) {
                        submitBtn.addClass('disabled');
                        disableBtn = true
                    }
                }
            })
        }

        for (let i = 0; i < this.ui.$allElementsFormStep2.length; i++) {
            // si un des champs n'est pas valid, on bloque le submit
            if (!this.ui.$allElementsFormStep2.eq(i)[0].validity.valid) {
                submitBtn.addClass('disabled');
                return false;
            }
        }

        if (disableBtn) {
            return false;
        }

        submitBtn.removeClass('disabled');
        return true;
    },

    initInputs: function () {
        this.ui.$form.find('input[type="radio"]:checked').click();
        $('.js-project-picture-reference-input option:selected').each(function (i, el) {
            let $container = $(el).parents('.js-project-picture-container');
            $container.find('.js-project-picture-input').val(el.text);
            // $container.find('.js-project-picture-submit').click();
        });
        $('.js-project-picture-container').each(function (i, el) {
            let $container = $(el);
            if ($container.find('.js-project-picture-input').val() !== '') {
                $container.find('.js-project-picture-submit').click();
            }
        });
    },

    onPopinFormAddressSubmit: function (e) {
        e.preventDefault();
        let $formAddress = $(e.currentTarget);
        const self = this
        $.ajax({
            method: 'POST',
            url: $formAddress.attr('action'),
            data: $formAddress.serializeArray(),
            success: (data) => {
                $('.js-infos-shipping-other-address').html(data.html)
                self.disableSubmitStep2IfNotValidForm()
                $formAddress.parents('.js-popin').find('.js-popin-close').click();
                $formAddress.find('.js-quote-request-address-shipping-form-error').hide();
            },
            error: (data) => {
                $formAddress.find('.js-quote-request-address-shipping-form-error').show();
            }
        })
    },
    showCarpet: function () {
        $('#typeCarpet input').prop('required', true);
        document.getElementById('typeCarpet').style.display = 'block';
        $('#typeRug input').prop('required', false);
        document.getElementById('typeRug').style.display = 'none';
        document.getElementsByClassName('js-type-checked')[0].style.display = 'none';
    },
    showRug: function () {
        $('#typeRug input').prop('required', true);
        document.getElementById('typeRug').style.display = 'block';
        $('#typeCarpet input').prop('required', false);
        document.getElementById('typeCarpet').style.display = 'none';
        document.getElementsByClassName('js-type-checked')[0].style.display = 'none';
    },
    showUpload: function () {
        document.getElementsByClassName('js-file')[0].classList.remove('disabled');
        document.getElementsByClassName('js-project-picture')[0].classList.add('disabled');
        document.getElementsByClassName('js-project-picture-product')[0].classList.add('disabled');
    },
    disableBtn: function () {
        document.getElementsByClassName('js-file')[0].classList.add('disabled');
        document.getElementsByClassName('js-project-picture')[0].classList.remove('disabled');
        document.getElementsByClassName('js-project-picture-product')[0].classList.remove('disabled');
    },
    disableBtnFabric: function (e) {
        let $this = $(e.currentTarget);
        let $container = $this.parents('.js-disable-btn-container');
        const disable = $this.data('disable');
        $container.find(`.js-disable-input-fabric`).addClass('disabled').addClass('js-hide').prop('required', false);
        $container.find(`.js-disable-input-fabric[data-disable="${disable}"]`).removeClass('disabled').removeClass('js-hide').prop('required', true);
    },
    guestShowButton: function () {
        document.getElementsByClassName('js-quoteRequestSubmit-btn')[0].classList.remove('disabled');
    },
    addressSelection: function () {
        this.ui.$addressSelection.each(i => {
            let $input = $('.js-shipping-address-hidden input').eq(i);
            if (this.ui.$addressSelection.eq(i).prop('checked')) {
                this.ui.$addressSelection.eq(i).parents('.js-address-shipping-selection').addClass('input-checked');
                $input.prop('checked', true)
            } else {
                this.ui.$addressSelection.eq(i).parents('.js-address-shipping-selection').removeClass('input-checked');
                $input.prop('checked', false);
            }
        })
    },
    addReference: function (e) {
        e.preventDefault();
        let list = document.getElementById('reference-fields-list');
        let counter = list.dataset.widgetCounter;
        counter++;
        let prototype = list.dataset.prototype;
        let newWidget = prototype.replace(/__name__/g, counter);

        let li = document.createElement('li');
        li.innerHTML = newWidget;

        $(li).find('.js-disable-btn-fabric').on('click', this.disableBtnFabric.bind(this))
        $(li).find('.js-project-picture-submit').on('click', this.onProjectPictureSubmitClick.bind(this));

        list.appendChild(li);
        // counter++;
        list.dataset.widgetCounter = counter;
    },
    showDimensions: function () {
        document.getElementById('dimensionsCatalog').style.display = 'block';
        document.getElementById('dimensionsCustom').style.display = 'none';
    },
    showDimensionsCustom: function () {
        document.getElementById('dimensionsCustom').style.display = 'block';
        document.getElementById('dimensionsCatalog').style.display = 'none';
    },
    showOneRef: function () {
        $('.js-required-if-fabric').attr('required', true);
        $('.js-required-if-one-fabric').attr('required', false).removeClass('required');
        $('.js-required-if-fabric').find("input[type=radio]:checked").click();
        document.getElementById('js-one-ref').style.display = 'block';
        document.getElementById('js-many-ref').style.display = 'none';
        document.getElementById('js-no-ref').style.display = 'none';
    },
    showManyRef: function () {
        $('.js-required-if-fabric').attr('required', true);
        $('.js-required-if-one-fabric').attr('required', true).addClass('required');
        $('.js-required-if-fabric').find("input[type=radio]:checked").click();
        document.getElementById('js-many-ref').style.display = 'block';
        document.getElementById('js-one-ref').style.display = 'block';
        document.getElementById('js-no-ref').style.display = 'none';
    },
    showNoRef: function () {
        $('.js-required-if-fabric').find("input,select,textarea").attr('required', false);
        $('.js-required-if-fabric').attr('required', false);
        $('.js-required-if-one-fabric').attr('required', false).removeClass('required');
        document.getElementById('js-many-ref').style.display = 'none';
        document.getElementById('js-one-ref').style.display = 'none';
        document.getElementById('js-no-ref').style.display = 'none';
    },
    subBtn: function () {
        let currentValue = parseInt(this.ui.$inputQuantity.val());
        if (isNaN(currentValue)) {
            this.ui.$inputQuantity = 1;
        } else {
            if (currentValue > 1) {
                this.ui.$inputQuantity.val(currentValue - 1);
            }
        }
    },
    addBtn: function () {
        let currentValue = parseInt(this.ui.$inputQuantity.val());
        if (isNaN(currentValue)) {
            this.ui.$inputQuantity = 1;
        } else {
            this.ui.$inputQuantity.val(currentValue + 1);
        }
    },

    onProjectPictureSubmitClick: function(e) {
        let $this = $(e.currentTarget);
        let $container = $this.parents('.js-project-picture-container');
        let $input = $container.find('.js-project-picture-input')
        const input = $input.val()
        let $product = $container.find('.js-project-picture-product');
        let $productInput = $product.find('.js-project-picture-reference-input');
        let $error = $container.find('.js-project-picture-error')
        $productInput.empty();
        if('' !== input){
            $.ajax({
                method: 'GET',
                url: ($this.data('url')+input),
            }).done(function (data) {
                if('success' === data.status){
                    let $projectPicture = $container.find('.js-project-picture');
                    let $img = $product.find('.js-project-picture-product-img');
                    let $code = $product.find('.js-project-picture-product-code');
                    let $family = $product.find('.js-project-picture-product-family');
                    let $name = $product.find('.js-project-picture-product-name');
                    $projectPicture.addClass('js-hide');
                    $product.removeClass('js-hide');

                    const env = $img.attr('data-env');
                    const path = ('dev' === env ? '' : $img.attr('data-asset-url')) + '/' + data.product.image;

                    $img.attr('src', path);
                    $code.html(data.product.code);
                    $family.html(data.product.family);
                    $name.html(data.product.name);

                    if(data.product.size) {
                        let $catalog = $('.js-from-catalog');
                        $catalog.find(".js-catalog-length").text(data.product.size.length);
                        $catalog.find(".js-catalog-depth").text(data.product.size.depth);
                        $catalog.find(".js-catalog-heightTotal").text(data.product.size.heightTotal);
                        $catalog.find(".js-catalog-heightSeat").text(data.product.size.heightSeat);
                    }

                    $container.find('.js-project-picture-product-delete').click(function (){
                        $projectPicture.removeClass('js-hide');
                        $product.addClass('js-hide');
                        $input.val(null);
                        $img.attr('src', '');
                        $code.html(null);
                        $family.html(null);
                        $name.html(null);
                        $productInput.empty();
                        $productInput.change();
                    })
                    // console.log(data)
                    $productInput.append(`<option value="${data.product.id}" selected>${data.product.code}</option>`);
                    $productInput.change();
                    $error.html("");
                } else if('error' === data.status){
                    $error.html(data.error);
                }
            })
        }
    },
}

module.exports = quoteRequest;